import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import { useState } from "react";

export default function LandingItalyWorks({ data }) {

  const videoRef = useRef(null);
  // const [isPlaying, setIsPlaying] = useState(false);
  const [showButton, setShowButton] = useState(true);

  const handlePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        // setIsPlaying(true);
        setShowButton(false)
      } else {
        videoRef.current.pause();
        // setIsPlaying(false);
      }
    }
  };

  // const handleHover = () => {
  //   setShowButton(true); // Show button when hovering over the video
  // };

  // const handleMouseLeave = () => {
  //   if (isPlaying) {
  //     setShowButton(false); // Hide the button only if the video is playing
  //   }
  // };

  return (
    <>
      <section className="land2-works">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-work-head text-center">
                <h3 className="heading gradiant-color">{data.title}</h3>
                <label>{data.desc}</label>
              </div>
            </div>

            {data.boxes && data.boxes.map((box, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="land2-works-box italy-land-box">
                  <img loading="lazy" src={`/assets/home/land2-work-${index + 1}.webp`} alt="logo" className="img-responsive" />
                  <div>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              </div>
            ))}

            <div className="col-lg-12">
              <div
                //       onMouseEnter={handleHover}
                // onMouseLeave={handleMouseLeave} 
                className="land2-work-video">
                <video ref={videoRef} src="/assets/home/land2-video.mp4" poster="/assets/home/land2-video-thumbnail.webp"></video>
                {showButton && (<span onClick={handlePlay} className="animated-btn"><FontAwesomeIcon icon={faPlay} /></span>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
